import { useStore } from '@/store/useStore';
import timeIcon from '@/assets/icons/clock.svg';
import timerIcon from '@/assets/icons/stop-watch.svg';
import logoIcon from '@/assets/icons/logo.svg';
import logo from '@/assets/images/logo.webp';
import { Icon } from '@/ui/components/base';
import { useTime } from '@/ui/hooks/useTime';
import { useTimer } from '@/ui/hooks/useTimer';
import { formatCurrency } from '@/ui/lib/utils';
import './topBar.css';

export const TopBar = () => {
    const currency = useStore((state) => state.currency);
    const balance = useStore((state) => state.balance);
    const netWin = useStore((state) => state.netWin);
    const time = useTime();
    const sessionTime = useTimer();

    return (
        <header className="top-bar">
            <div className="top-bar__content">
                <Icon className="top-bar__small-logo" src={logoIcon} />
                <div className="top-bar__stat">
                    <span className="top-bar__item-label">Balance</span>
                    <span className="top-bar__item-value">{formatCurrency(balance, currency)}</span>
                </div>

                <div className="top-bar__divider"></div>

                <div className="top-bar__stat">
                    <span className="top-bar__item-label">Net win</span>
                    <span className="top-bar__item-value">{formatCurrency(netWin, currency)}</span>
                </div>

                <div className="top-bar__divider"></div>

                <div className="top-bar__time">
                    <Icon src={timeIcon} className="top-bar__icon" />
                    <span className="top-bar__item-value">{time}</span>
                </div>
                <div className="top-bar__session-time">
                    <Icon src={timerIcon} className="top-bar__icon" />
                    <span className="top-bar__item-value">{sessionTime}</span>
                </div>
            </div>

            <img className="top-bar__logo" src={logo} alt="logo" />
        </header>
    );
};
